<template>
  <nav>
    <!-- h2>Dashboard</h2>
    <menu>
      <NavLink to="/" label="Home" icon="home" tooltip="Home" />
    </menu -->

    <h2>Allotments</h2>
    <menu>
      <NavLink to="/allotments" :notifications="rejectionsCount" label="Overview" icon="list" tooltip="Allotments Overview"/>
      <NavLink to="/allotments/evolution" label="Evolution" icon="timeline" tooltip="Allotments Evolution" />
    </menu>

    <span v-if="isFlightSearchAllowed">
      <h2>Flight Search</h2>
      <menu>
        <NavLink to="/search-flights" label="Search for flights" icon="search" tooltip="Search for flights" />
        <NavLink to="/purchase-overview" label="Purchase overview" icon="list" tooltip="Purchase overview" />
      </menu>
    </span>

    <span v-if="isPaxDataAllowed">
      <h2>Passengers</h2>
      <menu>
        <NavLink to="/passenger-data" label="Overview" icon="history" tooltip="Passengers Overview"/>
        <NavLink :to="{ name: 'passengerData', query: { upload: null }}" label="Upload" icon="upload" tooltip="Passengers Upload"/>
      </menu>
    </span>

    <h2>Reports</h2>
    <menu>
      <NavLink to="/reports/generate" label="Generate report" icon="analytics" tooltip="Generate Reports"/>
      <NavLink to="/reports" label="Overview" icon="history" tooltip="Reports Overview"/>
    </menu>

    <span v-if="isTourOperatorAllAccess || isTourOperatorOnlyReporting">
      <h2>Schedule changes</h2>
      <menu>
        <NavLink to="/schedule-changes" label="Overview" icon="history" tooltip="Schedule changes overview" />
      </menu>
    </span>
  </nav>
</template>
<script lang="ts">
import {mapState} from 'pinia';

import {useAllotmentsStore, useTourOperatorsStore} from '@/stores';

import NavLink from '@/components/structure/NavLink.vue';
import {useCurrentUserStore} from "@/stores/current-user-store.ts";

export default {
  components: {
    NavLink,
  },
  data: function () {
    return {
      isPaxDataAllowed: false,
      isFlightSearchAllowed: false,
    }
  },
  computed: {
    ...mapState(useAllotmentsStore, {
      rejectionsCount: 'rejectionsCount',
    }),
    ...mapState(useTourOperatorsStore, {
      getCurrent: 'getCurrent',
    }),
    ...mapState(useCurrentUserStore, [
      'isTourOperatorOnlyReporting',
      'isTourOperatorAllAccess'
    ]),
  },

  async mounted() {
    const tourOperatorRes = await this.getCurrent();
    this.isPaxDataAllowed = tourOperatorRes.isPaxDataUploadEnabled;
    this.isFlightSearchAllowed = tourOperatorRes.isPoolingEnabled;
  }
};
</script>
